/* eslint-disable */
import React from "react";
import { Outlet, useNavigate } from "react-router-dom";

import RaindropButton, {
  ButtonStyle,
} from "../../../ui-components/raindrop-button/raindrop-button.tsx";

import RaindropInput from "../../../ui-components/raindrop-input/raindrop-input.tsx";

import { useEffect, useState } from "react";
import NimbusTitle from "../../../ui-components/nimbus-title/nimbus-title.tsx";
import RaindropLoadingElement from "../../../ui-components/raindrop-loading-element/raindrop-loading-element.js";
import {
  fetchAuthenticationLogout,
  fetchSupportUserGet,
} from "../../../services/api-raindrop.js";
import Spacer from "../../../ui-components/spacer/spacer.js";
import RaindropDivider from "../../../ui-components/raindrop-divider/raindrop-divider.js";
import { VERSION } from "../../../services/constants.js";
import SVGRaindropLogoWithTitle from "../../../ui-components/svg-raindrop-logo-with-title/svg-raindrop-logo-with-title.js";
import RaindropModalComponent from "../../../ui-components/raindrop-modal-component/raindrop-modal-component.tsx";
import { Size } from "../../../logic/enums.ts";

const NimbusSideBar = ({ isZenMode = false, onNimbusLogout }) => {
  const border =
    "border-r border-color-border-primary dark:border-color-dark-border-primary";

  const background =
    "bg-color-background-secondary dark:bg-color-dark-background-secondary";

  let translate = "";

  if (isZenMode) {
    translate = "-translate-x-[250px] w-0";
    return;
  }

  return (
    <div
      className={`flex flex-col h-full w-[300px] px-2 transition-all ${translate}  ${border} ${background}`}
    >
      <div className="flex flex-col gap-4 h-full w-full py-6 ">
        <SidebarHeader text={"GENERAL"} />
        <RaindropButton
          title={"Dashboard"}
          icon={"fa-house"}
          to={"nimbus/home"}
          style={ButtonStyle.Tertiary}
        />
        <RaindropDivider />

        <SidebarHeader text={"USERS"} />
        <RaindropButton
          title={"Organisations"}
          icon={"fa-seedling"}
          to={"nimbus/organisations/index"}
          style={ButtonStyle.Tertiary}
        />
        <RaindropButton
          title={"Account Users"}
          icon={"fa-user"}
          to={"nimbus/users/index"}
          style={ButtonStyle.Tertiary}
        />

        <RaindropButton
          title={"Support Users"}
          icon={"fa-id-card-clip"}
          style={ButtonStyle.Tertiary}
          to={"nimbus/support-users/index"}
        />
        <RaindropButton
          title={"Manage Quiz"}
          icon={"fa-fire"}
          style={ButtonStyle.Tertiary}
          to={"nimbus/quiz"}
        />

        <RaindropDivider />

        <SidebarHeader text={"TOOLS"} />

        <RaindropButton
          title={"Developer Tools"}
          icon={"fa-code"}
          to={"nimbus/developer-tools/index"}
          style={ButtonStyle.Tertiary}
        />
        <RaindropButton
          title={"Reset Password"}
          icon="fa-key"
          to={"nimbus/reset-password"}
          style={ButtonStyle.Tertiary}
        />
        <RaindropButton
          title={"Logout"}
          icon={"fa-sign-out-alt"}
          onClick={onNimbusLogout}
          style={ButtonStyle.Tertiary}
        />
      </div>

      <div className="flex flex-col w-full items-center justify-center pb-6 gap-1 opacity-50">
        <SVGRaindropLogoWithTitle className="w-full h-4 fill-color-text-tertiary " />
        <div className="w-full text-center text-xs text-color-text-tertiary">
          v{VERSION}
        </div>
      </div>
    </div>
  );
};

const StaffMemberTopButton = ({ preferredName }) => {
  return (
    <div className="flex flex-row  gap-4 w-fit items-center">
      <div className="flex flex-col items-end ">
        <div className="text-xs font-medium text-color-text-secondary">
          Admin
        </div>
        <div className="font-bold text-sm whitespace-nowrap">
          {preferredName}
        </div>
      </div>
    </div>
  );
};

const NimbusSearchBar = () => {
  const navigate = useNavigate();
  const [searchValue, setSearchValue] = useState("");

  const onSubmit = (e) => {
    e.preventDefault();

    if (searchValue.startsWith("account_user__")) {
      navigate(`/nimbus/users/${searchValue}`);
    } else if (searchValue.startsWith("organisation__")) {
      navigate(`/nimbus/organisations/${searchValue}`);
    } else if (searchValue.startsWith("incident__")) {
      navigate(`/nimbus/incidents/${searchValue}`);
    }
    setSearchValue("");
  };

  return (
    <form
      onSubmit={onSubmit}
      className={`flex flex-row items-center w-full h-fit max-w-lg rounded-lg`}
    >
      <RaindropInput
        value={searchValue}
        onChange={(e) => setSearchValue(e.target.value)}
        placeholder={"Search..."}
        icon={null}
        style={ButtonStyle.Secondary}
        isShowingBorder={false}
        isPopulatingExampleIfLocal={false}
      />
    </form>
  );
};

const SidebarHeader = ({ text }) => {
  return (
    <div className="px-4 pt-2 font-semibold text-xs text-color-text-secondary">
      {text}
    </div>
  );
};

const NimbusTopBar = ({
  preferredName,
  isZenMode = false,
  setIsZenMode = (b) => {},
}) => {
  let background =
    "bg-color-background-secondary dark:bg-color-dark-background-secondary";
  let border =
    "border-b border-color-border-primary dark:border-color-dark-border-primary";

  if (isZenMode) {
    return (
      <div className="flex flex-row w-full items-end justify-end h-14 pb-6 ">
        <RaindropButton
          title={"Zen Mode"}
          icon={"fa-torii-gate"}
          style={ButtonStyle.Secondary}
          onClick={() => setIsZenMode(!isZenMode)}
          isHidingTitle={true}
        />
      </div>
    );
  }

  return (
    <div
      className={`flex flex-row w-full items-center justify-center gap-4 py-4 pr-4 ${background} ${border}`}
    >
      <div className="flex flex-row w-full max-w-[250px] px-6 ">
        <NimbusTitle />
      </div>

      <NimbusSearchBar />
      <Spacer />
      <div className="flex flex-row items-center justify-center ">
        <RaindropButton
          title={"Report Bug"}
          icon={"fa-bug"}
          style={ButtonStyle.Secondary}
          isHidingTitle={true}
        />

        <RaindropButton
          title={"Zen Mode"}
          icon={"fa-torii-gate"}
          onClick={() => setIsZenMode(!isZenMode)}
          style={ButtonStyle.Secondary}
          isHidingTitle={true}
        />
      </div>
      <RaindropDivider isVertical={true} />

      <StaffMemberTopButton preferredName={preferredName} />
    </div>
  );
};

const NimbusBaseAuthenticated = ({
  currentSupportUser,
  setCurrentSupportUser,
  currentModalComponent,
  setCurrentModalComponent,
}) => {
  const navigate = useNavigate();

  const [isZenMode, setIsZenMode] = useState(false);

  let blur = "blur-none";

  const onNimbusLogout = () => {
    fetchAuthenticationLogout({ application: "nimbus" }).then(() => {
      setCurrentSupportUser(null);
      navigate("/nimbus/login");
    });
  };

  useEffect(() => {
    // If user is already authenticated, do nothing
    if (currentSupportUser) {
      return;
    }

    // Fetch SupportUser data
    fetchSupportUserGet({ supportUserId: "current" })
      .then((user) => {
        setCurrentSupportUser(user);
      })
      .catch(() => {
        navigate("/nimbus/login");
      });
  }, [navigate]);

  if (!currentSupportUser) {
    return <RaindropLoadingElement />;
  }

  if (currentModalComponent) {
    blur = "blur-sm";
  }

  return (
    <div
      id={"nimbus-base-authenticated"}
      className={`flex flex-col w-screen h-full relative
        text-color-text-primary dark:text-color-dark-text-primary
        bg-color-background-primary dark:bg-color-dark-background-primary relative`}
    >
      {currentModalComponent && (
        <RaindropModalComponent
          setCurrentModalComponent={setCurrentModalComponent}
        >
          {currentModalComponent}
        </RaindropModalComponent>
      )}

      <div className={`flex flex-col w-full h-full ${blur}`}>
        <NimbusTopBar
          isZenMode={isZenMode}
          setIsZenMode={setIsZenMode}
          preferredName={currentSupportUser.name_legal}
        />

        <div className={`flex flex-row h-full w-full overflow-auto`}>
          <NimbusSideBar
            isZenMode={isZenMode}
            onNimbusLogout={onNimbusLogout}
          />
          <div className={`flex flex-col w-full h-full px-6`}>
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

export default NimbusBaseAuthenticated;
